<div class="footer-container">
  <div class="app-toolbar"></div>
</div>
